import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { safeDecodeURIComponent } from "@/lib/utils";

interface Item {
    id: string;
    url: string;
    title: string;
    intro: string;
    seo: string;
    imageurl: string;
    date: string;
   type?: "blog" | "casestudy";
}

interface Props {
    item: Item;
    type?: "blog" | "casestudy";
}
function decodeHtmlEntities(input?: string) {
    if (!input) return "";
    const txt = typeof document !== "undefined" ? document.createElement("textarea") : null;
    if (!txt) return input;
    txt.innerHTML = input;
    return txt.value;
}

export default function BlogItemCard({ item,  type }: Props) {

     const displayItem = { ...item, type: type ?? item.type };

    return (
        <div className="group relative bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
            {/* Image Container */}
            <div className="relative h-56 overflow-hidden">
                <img
                    className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
                    src={item.imageurl}
                    alt={item.title}
                    loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Read Time Badge */}
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <Clock className="w-3 h-3 text-gray-600" />
                    <span className="text-xs font-medium text-gray-700">3 min read</span>
                </div>
            </div>

            {/* Content */}
            <div className="p-6">                

                {/* Title */}
                <h2 className="font-bold text-gray-900 text-lg mb-3 line-clamp-2 group-hover:text-harvey-red transition-colors duration-300">
                    {decodeHtmlEntities(safeDecodeURIComponent(item.title))}
                </h2>

                {/* Intro */}
                <p className="text-gray-600 text-sm line-clamp-3 leading-relaxed mb-4">
                    {decodeHtmlEntities(safeDecodeURIComponent(item.intro))}
                </p>

                {/* Read More Link */}
                                {/*4/12/25 original: /resources/blogs/${item.url}  */}
                {/* <Link 
                    to={`/blogs/${item.url}`}
                    className="inline-flex items-center gap-2 text-harvey-red font-semibold text-sm hover:gap-3 transition-all duration-300 group/link"
                >
                    <span>Read Article</span>
                    <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-300" />
                </Link> */}
                {/* <Link 
                to={`/${displayItem.type === "casestudy" ? "casestudies" : "blog"}/${displayItem.url}`}
                className="inline-flex items-center gap-2 text-harvey-red font-semibold text-sm hover:gap-3 transition-all duration-300 group/link"
            >
                <span>Read Article</span>
                <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-300" />
            </Link> */}
            <Link 
                to={`/${displayItem.type === "casestudy" ? "case-studies" : "blogs"}/${displayItem.url}/`}
                className="inline-flex items-center gap-2 text-harvey-red font-semibold text-sm hover:gap-3 transition-all duration-300 group/link"
            >
                <span>Read Article</span>
                <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-300" />
            </Link>
            </div>

            {/* Hover Effect Border */}
            <div className="absolute inset-0 border-2 border-harvey-red/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
        </div>
    )
}